import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
import { IDropdownOption } from'@ar2/common'
/**
 * テーブルアクションリスト
 *【ラベル内容:labelContent:string】
 *【アクションリスト:options:IDropdownOption[]】
 *【表示条件:visible:boolean】
 *【内容:content:string】
 *【非活性:disabled:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-action-list',
  templateUrl: './action-list.html',
  styles: [`
    .list-postion {
      padding-top: 5px;
    }
  `]
})
export class ActionList extends BaseWidget {
  /**
   * 内容の表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 内容に対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * ラベル内容
   */
  @Input() labelContent:string

  /**
   * アクションリスト
   */
  @Input() options:IDropdownOption[]

  /**
   * 表示条件
   */
  @Input() visible:boolean

  /**
   * 内容
   */
  @Input() content:string

  /**
   * 非活性
   */
  @Input() disabled:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  get items() {
    const items = {
      dispType : 'display-text-button',
      options : !!this.options ? this.options : []
    }
    return items;
  }
  onSelectOption(data) {
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => data.selectedOption.value,
      {id:this.id, type:data.event.type, source:data.event},
      `update by ${this.id}`,
    ))
    this.on(data.event);
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/table/action-list/action-list.component.ts